"use strict";

(function () {
  if (customElements.get("slideshow-banner")) return;

  class SlideshowBanner extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.swiper = null;
      this.thumbnails = null;
      this.thumbnailsContent = null;
      this.pagination = null;
    }

    connectedCallback() {
      this.setupElements();
      if (!this.slider) return;
      this.initSwiper();
      this.initThumbnailListeners();
    }

    disconnectedCallback() {
      if (this.swiper) {
        this.swiper.destroy();
      }
    }

    setupElements() {
      this.slider = this.querySelector('[data-component="slider"]');
      this.thumbnails = this.querySelectorAll('[data-component="thumbnail"]');
      this.thumbnailsContent = this.querySelectorAll(
        '[data-component="thumbnail-content"]',
      );
      this.pagination = this.querySelector('[data-component="pagination"]');
    }

    initSwiper() {
      let { autoplay, rotate } = this.dataset;
      rotate = +rotate * 1000;
      const autoplayOptions =
        autoplay === "true"
          ? {
              delay: rotate,
              disableOnInteraction: false,
            }
          : false;

      this.swiper = new Swiper(this.slider, {
        slidesPerView: 1,
        grabCursor: true,
        autoplay: autoplayOptions,
        pagination: {
          el: this.pagination,
          clickable: true,
        },
        on: {
          init: () => this.handleSlideChange(),
          slideChange: () => this.handleSlideChange(),
        },
      });
    }

    initThumbnailListeners() {
      this.thumbnails.forEach((thumbnail, index) => {
        thumbnail.addEventListener("click", () => {
          if (this.swiper) {
            this.swiper.slideTo(index);
          }
        });
      });
    }

    handleSlideChange() {
      if (!this.swiper) return;

      const activeIndex = this.swiper.activeIndex;

      this.thumbnails.forEach((thumbnail, index) => {
        thumbnail.classList.toggle("active", index === activeIndex);
      });

      this.thumbnailsContent.forEach((content, index) => {
        content.classList.toggle("active", index === activeIndex);
      });
    }
  }

  customElements.define("slideshow-banner", SlideshowBanner);
})();
